import Banner from '@rio-cloud/rio-uikit/Banner';
import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import driverImage from './assets/driver.png';
import utils from './utils';

export default function DriverAppBanner({ shouldShowBanner }: { shouldShowBanner: boolean }) {
    const { hideForever, showNextWeek, shouldShowToday } = utils;
    const [showBanner, setShowBanner] = useState<boolean>(shouldShowBanner && shouldShowToday());
    const [checkedState, setCheckedState] = useState(false);

    const LearnMoreLink = injectIntl(({ intl }) => {
        const link = intl.formatMessage({ id: 'driverapp.banner.url' });
        return (
            <a
                href={link}
                target="_blank"
                className="btn btn-primary"
                data-test="driver-app-promo-learn-more"
                data-track-ga-event-trigger="click"
                data-track-ga-event-name="perform_driver_app_promo_clicked"
                data-track-ga-event-element-name="learnMore"
                rel="noreferrer"
            >
                <FormattedMessage id="driverapp.banner.learnmore" />
            </a>
        );
    });

    return showBanner ? (
        <div className="margin-bottom-20">
            <Banner
                show={showBanner}
                data-test="driver-app-promo-dismiss"
                data-track-ga-event-trigger="click"
                data-track-ga-event-name="perform_driver_app_promo_clicked"
                data-track-ga-event-element-name="dismiss"
                onClose={() => {
                    showNextWeek();
                    setShowBanner(false);
                }}
            >
                <Banner.Page>
                    <Banner.Icon>
                        <img src={driverImage} alt="Driver App" className="height-100" />
                    </Banner.Icon>
                    <Banner.Content
                        title={<FormattedMessage id="driverapp.banner.title" />}
                        actions={
                            <Banner.Actions>
                                <LearnMoreLink />
                            </Banner.Actions>
                        }
                    >
                        <div className="text-size-14 line-height-150rel">
                            <FormattedMessage id="driverapp.banner.content" />
                        </div>
                        <Checkbox
                            className="margin-top-10"
                            data-test="driver-app-promo-dont-show-again"
                            data-track-ga-event-trigger="click"
                            data-track-ga-event-name="perform_driver_app_promo_clicked"
                            data-track-ga-event-element-name="dontShowAgain"
                            data-track-ga-event-element-state={checkedState}
                            onChange={(event) => {
                                const checked = event.currentTarget.checked;
                                setCheckedState(checked);
                                hideForever(checked);
                            }}
                        >
                            <FormattedMessage id="driverapp.banner.checkbox" />
                        </Checkbox>
                    </Banner.Content>
                </Banner.Page>
            </Banner>
        </div>
    ) : null;
}
